<template>
	<h5 class="mb-2">补小帅商家操作文档</h5>
	<el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
		<recursive-menu-item 
			:menu-items="menus"
			@click-item="toArticle"
		/>
	</el-menu>
</template>

<script>
	import RecursiveMenuItem from './RecursiveMenuItem.vue'
	
	export default {
		name: 'Sidebar',
		components: {
			RecursiveMenuItem
		},
		data() {
			return {
				menus: []
			};
		},
		created() {
			this.getmenus();
		},
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			getmenus() {
				let _this = this;
				//获取菜单
				_this.$axios.get('/index/index/getArticleCategory').then(res => {
					_this.menus = res.data.data
				})
			},
			toArticle(id) {
				this.$router.push({
					path: '/article',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style>
</style>